module.exports = __webpack_public_path__ + "static/img/logo.57ec8563.svg";